// extracted by mini-css-extract-plugin
export var animationContainer = "_jx-0";
export var footer = "_jx-1";
export var gray = "_jx-2";
export var lineItem = "_jx-3";
export var lineItemImage = "_jx-4";
export var lineItemInfo = "_jx-5";
export var lineItemText = "_jx-6";
export var lineItems = "_jx-7";
export var modalContent = "_jx-8";
export var options = "_jx-9";
export var orderName = "_jx-a";
export var refundAmount = "_jx-b";